import React from 'react';
import { NavLink } from 'react-router-dom';
import './Nav.css';

const Nav = () => {
  return (
    <nav className="nav">
      <div className="nav-brand">
        <span className="nav-logo">AMDB</span>
        <span className="nav-tagline">Andrew's Movie Database</span>
      </div>
      <div className="nav-links">
        <NavLink to="/" end className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
          Random
        </NavLink>
        <NavLink to="/search" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
          Search
        </NavLink>
      </div>
    </nav>
  );
};

export default Nav;
